"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Mission() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const milestones = [{
    year: "2018",
    label: "\n"
  }, {
    year: "2020",
    label: "LOYALTY"
  }, {
    year: "2022",
    label: "TEAMWORK"
  }, {
    year: "2024",
    label: "INTEGRATY"
  }];
  return <section data-section-id="789" id="nuestra-misión-en-vancouver" className="relative overflow-hidden bg-background text-foreground py-24 md:py-32 lg:py-[180px]">
      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono uppercase tracking-[0.3em] text-primary !text-3xl" style={{
          color: "var(--primary)"
        }}>— ABOUT US&nbsp;</p>
          
          <div className="mx-auto mt-10 h-16 w-px" style={{
          backgroundColor: "var(--primary)"
        }} aria-hidden="true" />
        </div>

        {}
        <div ref={contentRef} className={`mt-20 grid grid-cols-1 gap-12 transition-all duration-1000 ease-out lg:mt-28 lg:grid-cols-12 lg:gap-16 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="relative overflow-hidden rounded-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/construction_site_vancouver.webp" alt="Sitio de construcción de Formexa en Vancouver" loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover" src="https://genuine-manatee.10web.cloud/wp-content/uploads/2026/06/9476af5f-a925-49dc-a314-8490561456fd.jpg" />
              </div>
              
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="max-w-2xl space-y-8">
              {}
              <p className="leading-[1.7] text-foreground !text-lg"><div data-ast-id="f:/src/pages/Company/sections/Mission.tsx|sig:54g9v3" data-ast-start="2420" data-ast-end="2546"><br /></div><div data-ast-id="f:/src/pages/Company/sections/Mission.tsx|sig:53v2uh" data-ast-start="2546" data-ast-end="2706" contenteditable="false">Formexa</div><div data-ast-id="f:/src/pages/Company/sections/Mission.tsx|sig:52u1lu" data-ast-start="2706" data-ast-end="2832" style={{}}><br /></div><div data-ast-id="f:/src/pages/Company/sections/Mission.tsx|sig:528f0n" data-ast-start="2832" data-ast-end="3209">Formexa is a construction company based in Vancouver, British Columbia, specializing in concrete formwork, and general construction services. We are committed to delivering quality workmanship, reliable service, and safe job site practices on every project.</div><div data-ast-id="f:/src/pages/Company/sections/Mission.tsx|sig:4oiwdq" data-ast-start="3209" data-ast-end="3335"><br /></div><div data-ast-id="f:/src/pages/Company/sections/Mission.tsx|sig:4nxpd4" data-ast-start="3335" data-ast-end="3781">Our team focuses on professionalism, efficiency, and strong coordination to ensure every project is completed on time and to the highest standards. Whether working on residential, commercial, or industrial projects, we strive to build lasting relationships through integrity, quality, and dependable results.  </div></p>

              {}
              <div className="my-12 border-y py-8 text-center" style={{
              borderColor: "var(--border)"
            }}>
                
              </div>

              {}
              <p className="leading-[1.7] text-primary !text-base"><span className="!text-4xl">OUR MISION</span><span className="text-accent-foreground"><span className="!text-4xl"></span><span className="!text-base"><span className="!text-4xl"></span><br /><br />Provide our customers and partners with added value in our services throughout the construction process guaranteeing 100% satisfaction,</span> saving overhead, training and management costs through great performance in all our services by each member of FORMEXA TEAM</span><br /><br /></p>

              {}
              <p className="leading-[1.7] text-foreground !text-base"><span className="!text-justify !text-4xl !text-[rgba(220,40,40,1)]" data-ast-id="f:/src/pages/Company/sections/Mission.tsx|sig:2okxo6" data-ast-start="4823" data-ast-end="5048" contenteditable="false" style={{}}>VISION</span> <br /><br /><br />Become the leading company chosen for the excellence of our projects that we carry out with a highly qualified workforce contributing to the development of the country.<br /><br /></p>

              {}
              <div className="pt-2">
                
              </div>
            </div>
          </div>
        </div>

        {}
        <div ref={timelineRef} className={`mt-24 transition-all duration-1000 ease-out lg:mt-32 ${timelineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="relative">
            <div className="absolute left-0 right-0 top-1/2 h-px -translate-y-1/2" style={{
            backgroundColor: "var(--primary)",
            opacity: 0.4
          }} aria-hidden="true" />
            <div className="relative -mx-6 overflow-x-auto px-6 md:mx-0 md:overflow-visible md:px-0">
              <div className="grid min-w-[640px] grid-cols-4 gap-6 md:min-w-0">
                {milestones.map((milestone, i) => <div data-index={i} key={milestone.year} className="relative flex flex-col items-center text-center">
                    
                    <div className="my-4 h-3 w-px" style={{
                  backgroundColor: "var(--primary)"
                }} aria-hidden="true" />
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-foreground !text-left">
                      {milestone.label}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute -bottom-8 -right-12 select-none overflow-hidden md:-bottom-16 md:-right-20 lg:-bottom-24 lg:-right-32" aria-hidden="true">
        <p className="font-default text-[18vw] font-bold leading-none tracking-tight md:text-[16vw] lg:text-[14vw]" style={{
        color: "var(--card)",
        opacity: 0.5
      }}>
          FORMEXA
        </p>
      </div>
    </section>;
}